export const getDeviceImg = (img, deviceName, imgListMap) => {
  let imgUrl = require('@/assets/images/default-device.png')
  if (img) {
    if (img.indexOf('http:') || img.indexOf('https:')) {
      imgUrl = img
    } else {
      imgUrl = 'data:image/png;base64,' + img
    }
  } else {
    if (imgListMap[deviceName]) {
      imgUrl = imgListMap[deviceName]
    }
  }

  return imgUrl
}

// 文件流下载
export const downloadFile = (content, filename) => {
  let a = document.createElement('a')
  a.download = filename
  a.style.display = 'none'
  let url = URL.createObjectURL(content)
  a.href = url
  document.body.appendChild(a)
  a.click()
  URL.revokeObjectURL(url) // 销毁
  document.body.removeChild(a)
}
